import React, { useState, useCallback, useRef, useEffect } from "react";
import ImageUploader from "./components/ImageUploader";
import SubmissionForm from "./components/SubmissionForm";
import { Box, Typography, Card } from "@mui/material";
import Confetti from "react-confetti";
import { auth } from "./firebase/firebase";
import { signInAnonymously, onAuthStateChanged } from "firebase/auth";

function App() {
   useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        console.log("Signing in anonymously...");
        signInAnonymously(auth)
          .then(() => console.log("Signed in anonymously"))
          .catch((err) => console.error("Anonymous sign-in failed:", err));
      } else {
        console.log("User already signed in:", user.uid);
      }
    });
    return unsubscribe;
  }, []);

  const [selectedFile, setSelectedFile] = useState(null);
  const [resetSignal, setResetSignal] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);
  const containerRef = useRef(null);

  const handleFileSelect = (file) => {
    console.log("File selected:", file ? file.name : "null");
    setSelectedFile(file);
  };

  const resetForm = useCallback(() => {
    console.log("Resetting form");
    setSelectedFile(null);
    setResetSignal((prev) => prev + 1);
  }, []);

  const handleSuccess = () => {
    console.log("Submission successful, triggering confetti");
    setShowConfetti(true);
  };

  useEffect(() => {
    if (showConfetti) {
      const timer = setTimeout(() => {
        console.log("Confetti timeout, resetting");
        setShowConfetti(false);
        resetForm();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showConfetti, resetForm]);

  const getContainerDimensions = () => {
    if (containerRef.current) {
      const { width, height } = containerRef.current.getBoundingClientRect();
      console.log("Container dimensions:", { width, height });
      return { width, height };
    }
    return { width: 0, height: 0 };
  };

  return (
    <Box
      ref={containerRef}
      sx={{
        p: 4,
        bgcolor: "#f5f5f5",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <Card
        sx={{
          borderRadius: ".625rem .625rem 0 0 !important",
          overflow: "hidden",
          boxShadow: "0 0.375rem 1.875rem rgba(0, 0, 0, 0.25)",
          margin: "1.25rem 0 0",
          backgroundColor: "white",
          maxWidth: 600,
          mx: "auto",
          pt: 3,
          pb: 2,
        }}
      >
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold", color: "#333" }}
        >
          Image Submission Portal
        </Typography>
        <ImageUploader
          onFileSelect={handleFileSelect}
          resetSignal={resetSignal}
        />
        <SubmissionForm
          selectedFile={selectedFile}
          onSuccess={handleSuccess}
          reset={resetForm}
        />
      </Card>
      {showConfetti && (
        <Confetti
          width={getContainerDimensions().width}
          height={getContainerDimensions().height}
          numberOfPieces={200}
          recycle={false}
          style={{ position: "absolute", top: 0, left: 0 }}
        />
      )}
    </Box>
  );
}

export default App;
